import { createFileRoute, useNavigate } from '@tanstack/react-router';
import React, { useEffect } from 'react';

import { useGame, useTournament } from '~/apis';
import { useTranslation } from '~/app';
import { getRouteHead } from '~/app/routeHead';
import Container from '~/components/Container';
import LoadingSpinner from '~/components/LoadingSpinner/LoadingSpinner';
import { getCachedJoinableGame, getCachedTournament } from '~/play/join/modeResolution';

export const Route = createFileRoute('/games/$id/spectate')({
  component: GameSpectateRoute,
  head: ({ params }) => getRouteHead({ title: params.id ? `Spectate · ${params.id}` : 'Spectate' }),
});

function GameSpectateRoute() {
  const { id } = Route.useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gameQuery = useGame(id, {
    enabled: !!id,
    staleTime: 15000,
    initialData: () => getCachedJoinableGame(id),
  });
  const tournamentQuery = useTournament(id, {
    enabled: !!id,
    staleTime: 15000,
    initialData: () => getCachedTournament(id),
  });

  useEffect(() => {
    if (!id) return;
    if (gameQuery.data) {
      navigate({ to: '/freegames/$id/spectate', params: { id }, replace: true });
      return;
    }
    if (tournamentQuery.data) {
      navigate({ to: '/tournaments/$id/join', params: { id }, replace: true });
    }
  }, [gameQuery.data, id, navigate, tournamentQuery.data]);

  const isLoading = gameQuery.isPending || tournamentQuery.isPending;
  return (
    <Container header={t('play_gameHeader')} className="max-w-3xl">
      <div className="relative rounded-md bg-white p-4 shadow-md">
        <h3 className="text-xl font-bold">
          {isLoading ? t('play_gameCheck') : t('play_linkError')}
        </h3>
        {isLoading && <LoadingSpinner size="sm" className="absolute top-4 right-4" />}
      </div>
    </Container>
  );
}
